var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
  'wgt-user-container': true,
}},_vm._l((_vm.value.data[_vm.value.joinStatus]?.template),function(wgt,index){return _c(wgt.name,{key:`content-part-component__${index}`,tag:"component",attrs:{"value":wgt}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }